import { Alert, Divider, Grid, MenuItem, Stack, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import FormikSelect from "../../../commons/formik/formikSelect";
import FormikSelectMultiple from "../../../commons/formik/formikSelectMultiple";
import FormikTextField from "../../../commons/formik/formikTextField";
import { StyledForm } from "../../../styled/form";
import { StyledNotificacionNuevoForm } from "../../../styled/notificaciones";
import { getNotificacionNuevoValidationSchema } from "./notificacionNuevoValidationSchema";

const NotificacionNuevoForm = ({
    allArtValue,
    initialValues,
    availableArts,
    availableMessages,
    providers,
    isProvidersLoading,
    categories,
    hasEnabledArts,
    onArtChange,
    onCategoryChange,
    onSend,
}) => {
    return (
        <StyledNotificacionNuevoForm.PageContainer>
            <StyledNotificacionNuevoForm.Container>
                <StyledNotificacionNuevoForm.Content>
                    <Typography variant="h5" mb={2}>
                        Notificaciones a Prestadores - Nuevo
                    </Typography>

                    <Formik
                        enableReinitialize
                        validateOnMount
                        initialValues={initialValues}
                        validationSchema={getNotificacionNuevoValidationSchema(allArtValue)}
                        onSubmit={async (values, { setSubmitting, resetForm }) => {
                            try {
                                await onSend(values);
                                resetForm({ values: initialValues });
                            } finally {
                                setSubmitting(false);
                            }
                        }}>
                        {({ values, isValid, isSubmitting, setFieldValue, resetForm }) => {
                            const handleArtChange = (value) => {
                                setFieldValue("selectedProviders", []);

                                if (onArtChange) {
                                    onArtChange(value);
                                }
                            };

                            const handleCategoryChange = (value) => {
                                setFieldValue("selectedMessage", "");
                                setFieldValue("description", "");

                                if (onCategoryChange) {
                                    onCategoryChange(value);
                                }
                            };

                            const handleMessageChange = (value) => {
                                const selectedMessageData = availableMessages.find(
                                    (message) => String(message.value) === String(value),
                                );

                                setFieldValue("description", selectedMessageData?.descripcion || "");
                            };

                            const handleCancel = () => {
                                resetForm({ values: initialValues });

                                if (onArtChange) {
                                    onArtChange(allArtValue);
                                }
                            };

                            return (
                                <Form>
                                    {values.selectedArt === allArtValue && (
                                        <StyledNotificacionNuevoForm.InfoAlert severity="info">
                                            Al seleccionar "todas" se enviara un mail a todos los prestadores de todas las
                                            arts con comunicacion habilitada.
                                        </StyledNotificacionNuevoForm.InfoAlert>
                                    )}

                                    <StyledNotificacionNuevoForm.FormStack spacing={3}>
                                        {!hasEnabledArts && (
                                            <Alert severity="warning">
                                                No hay ART habilitadas para notificacion. Revise la configuracion de ART.
                                            </Alert>
                                        )}

                                        <StyledNotificacionNuevoForm.FormGrid container spacing={2.5}>
                                            <Grid item xs={12} md={4}>
                                                <FormikSelect
                                                    name="selectedArt"
                                                    label="ART"
                                                    variant="outlined"
                                                    callBack={handleArtChange}>
                                                    <MenuItem value={allArtValue}>Todas</MenuItem>
                                                    {availableArts.map((art) => (
                                                        <MenuItem key={art.id} value={art.id}>
                                                            {art.nombreCorto || art.nombre}
                                                        </MenuItem>
                                                    ))}
                                                </FormikSelect>
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                                <FormikSelectMultiple
                                                    name="selectedProviders"
                                                    label="Prestador"
                                                    variant="outlined"
                                                    disabled={
                                                        values.selectedArt === allArtValue ||
                                                        isProvidersLoading ||
                                                        providers.length === 0
                                                    }
                                                    getOptionLabel={(value) => {
                                                        const provider = providers.find(
                                                            (item) => Number(item.id) === Number(value),
                                                        );
                                                        return provider?.nombre || provider?.Nombre || String(value);
                                                    }}>
                                                    {providers.map((provider) => (
                                                        <MenuItem key={provider.id} value={provider.id}>
                                                            {provider.nombre || provider.Nombre}
                                                        </MenuItem>
                                                    ))}
                                                </FormikSelectMultiple>
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                                <FormikSelect
                                                    name="selectedCategory"
                                                    label="Tipo de Gestion"
                                                    variant="outlined"
                                                    callBack={handleCategoryChange}>
                                                    {categories.map((category) => (
                                                        <MenuItem key={category} value={category}>
                                                            {category}
                                                        </MenuItem>
                                                    ))}
                                                </FormikSelect>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormikSelect
                                                    name="selectedMessage"
                                                    label="Seleccione un mensaje"
                                                    variant="outlined"
                                                    disabled={!values.selectedCategory}
                                                    callBack={handleMessageChange}>
                                                    {availableMessages.map((message) => (
                                                        <MenuItem key={message.value} value={message.value}>
                                                            {message.nombre}
                                                        </MenuItem>
                                                    ))}
                                                </FormikSelect>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormikTextField
                                                    name="description"
                                                    label="Descripcion de la Notificacion"
                                                    multiline
                                                    minRows={7}
                                                    disabled={!values.selectedMessage}
                                                />
                                            </Grid>
                                        </StyledNotificacionNuevoForm.FormGrid>

                                        <Divider />

                                        <Stack direction="row" justifyContent="flex-end" spacing={2}>
                                            <StyledForm.Button type="button" variant="outlined" onClick={handleCancel}>
                                                Cancelar
                                            </StyledForm.Button>
                                            <StyledForm.Button
                                                variant="contained"
                                                disabled={!isValid || isSubmitting || !hasEnabledArts}
                                                type="submit">
                                                Enviar
                                            </StyledForm.Button>
                                        </Stack>
                                    </StyledNotificacionNuevoForm.FormStack>
                                </Form>
                            );
                        }}
                    </Formik>

                </StyledNotificacionNuevoForm.Content>
            </StyledNotificacionNuevoForm.Container>
        </StyledNotificacionNuevoForm.PageContainer>
    );
};

export default NotificacionNuevoForm;
